'use strict';

var _ = require('lodash');
var CompetitorDataGridDataService = function CompetitorDataGridDataService(restangular, SearchCriteriaRule, RsqlQuery, $q, momentService, legendFilterService, hepService, configurationService, searchCriteriaService, competitorDataFilterService) {
  var shoppingRest = restangular.one('priceRecommendationShoppingData').one('flattened');
  var hepFpNestingRest = restangular.one('configuration').one('hep');
  var fpNestingsCache = {};
  var fpMarketConfigCache = {};
  function isMatchingCompFromSelectedService(compToLowest, competitorFare, direction) {
    return !_.chain(compToLowest).find({
      compCarrier: competitorFare.marketingCarrier,
      flightNbrs: direction === 'Outbound' ? competitorFare.outboundFlightNumberList : competitorFare.inboundFlightNumberList,
      direction: direction,
      fare: getFareInHostCurrency(direction, competitorFare)
    }).isUndefined().value();
  }
  function getFareInHostCurrency(direction, competitorFare) {
    if (direction === 'Outbound') {
      return competitorFare.grossFareOutboundHostCurrency ? competitorFare.grossFareOutboundHostCurrency : competitorFare.outboundGrossFareLocal;
    }
    return competitorFare.grossFareInboundHostCurrency ? competitorFare.grossFareInboundHostCurrency : competitorFare.inboundGrossFareLocal;
  }
  function mapSource(source) {
    switch (source) {
      case 'SHOPPINGDATA':
      case 'ORGANIC':
        return 'Market place';
      case 'COMPETITORFARE':
        return 'Web fares';
      default:
        return '';
    }
  }
  function combineFltNumbersWithMarketingCarriers(flightNumberList, marketingCarrierList, marketingCarrier) {
    var flightNbrs = flightNumberList.split(',');
    if (!marketingCarrierList || marketingCarrierList.split(',').length !== flightNbrs.length) {
      return _.map(flightNbrs, function (fltNbr) {
        return marketingCarrier + fltNbr;
      }).join(',');
    } else {
      var marketingCarriers = marketingCarrierList.split(',');
      return _.zipWith(marketingCarriers, flightNbrs, function (carrier, fltNbr) {
        return carrier + fltNbr;
      }).join(',');
    }
  }
  function transform(flattenedCompetitorData, service) {
    var compToLowest = service.compToLowest;
    var compToLowestTOD = service.compToLowestTOD;
    return _.chain(flattenedCompetitorData).sortBy(function (competitorFare) {
      return parseInt(competitorFare.itineraryId, 10) || 0;
    }).reduce(function (result, competitorFare, itineraryIdIndex) {
      var market = competitorFare.marketOrigin + '-' + competitorFare.marketDestination;
      var itinIdHumanized = itineraryIdIndex + 1;
      if (isMatchingSelectedCabin(competitorFare, 'Outbound')) {
        result.push({
          direction: 'Outbound',
          market: market,
          pos: competitorFare.pos,
          carrier: competitorFare.marketingCarrier,
          fare: competitorFare.grossFare,
          fbc: _.get(competitorFare, 'outboundFareBasisCode', _.get(competitorFare, 'outboundFareBasisCodes')),
          rbd: competitorFare.outboundSegmentClassNames,
          departureDate: momentService.of(competitorFare.outboundDepartureDate, momentService.FIELD.PRICING_DEPARTURE_DATE),
          departureTime: momentService.of(competitorFare.outboundDepartureTime, momentService.FIELD.PRICING_DEPARTURE_TIME, momentService.FORMAT.TIME_ISO),
          currency: competitorFare.currency,
          flightNo: combineFltNumbersWithMarketingCarriers(competitorFare.outboundFlightNumberList, competitorFare.outboundMarketingCarrierList, competitorFare.marketingCarrier),
          isLowestCompetitor: isMatchingCompFromSelectedService(compToLowest, competitorFare, 'Outbound'),
          isLowestCompetitorTOD: isMatchingCompFromSelectedService(compToLowestTOD, competitorFare, 'Outbound'),
          oneWayFare: competitorFare.outboundGrossFareLocal,
          itineraryId: itinIdHumanized,
          source: mapSource(competitorFare.source),
          eventTimeStamp: momentService.of(competitorFare.eventTimeStamp, momentService.FIELD.DEPARTURE_DATE)
        });
      }
      if (isMatchingSelectedCabin(competitorFare, 'Inbound')) {
        result.push({
          direction: 'Inbound',
          market: market,
          pos: competitorFare.pos,
          carrier: competitorFare.marketingCarrier,
          fare: competitorFare.grossFare,
          fbc: _.get(competitorFare, 'inboundFareBasisCode', _.get(competitorFare, 'inboundFareBasisCodes')),
          rbd: competitorFare.inboundSegmentClassNames,
          departureDate: momentService.of(competitorFare.inboundDepartureDate, momentService.FIELD.PRICING_DEPARTURE_DATE),
          departureTime: momentService.of(competitorFare.inboundDepartureTime, momentService.FIELD.PRICING_DEPARTURE_TIME, momentService.FORMAT.TIME_ISO),
          currency: competitorFare.currency,
          flightNo: combineFltNumbersWithMarketingCarriers(competitorFare.inboundFlightNumberList, competitorFare.inboundMarketingCarrierList, competitorFare.marketingCarrier),
          isLowestCompetitor: isMatchingCompFromSelectedService(compToLowest, competitorFare, 'Inbound'),
          isLowestCompetitorTOD: isMatchingCompFromSelectedService(compToLowestTOD, competitorFare, 'Inbound'),
          oneWayFare: competitorFare.inboundGrossFareLocal,
          itineraryId: itinIdHumanized,
          source: mapSource(competitorFare.source),
          eventTimeStamp: momentService.of(competitorFare.eventTimeStamp, momentService.FIELD.DEPARTURE_DATE)
        });
      }
      return result;
    }, []).value();
  }
  function isMatchingSelectedCabin(compFare, direction) {
    var key = compFare.marketingCarrier + '.' + compFare.marketOrigin + '.' + compFare.marketDestination;
    var nesting = fpNestingsCache[key];
    var cabin;
    if (direction === 'Outbound') {
      cabin = getCabinForClass(nesting, compFare.outboundSegmentClassNames.split(',')[0]);
    } else {
      if (compFare.inboundSegmentClassNames) {
        cabin = getCabinForClass(nesting, compFare.inboundSegmentClassNames.split(',')[0]);
      }
    }
    var selectedCabin = legendFilterService.getSelectedCabin();
    return cabin === selectedCabin;
  }
  function getCarriers(competitorCompFares) {
    return _.chain(competitorCompFares).map('marketingCarrier').uniq().value();
  }
  function getCabinForClass(nesting, className) {
    var nestingParamForClass = _.find(nesting, {
      className: className
    });
    return !_.isUndefined(nestingParamForClass) ? nestingParamForClass.cabinCode : null;
  }
  function filter(promisesData, originalService, sources) {
    return $q.all(promisesData).then(function (data) {
      var competitorCompFares = _.first(data);
      return competitorDataFilterService.filterCompFares(competitorCompFares, originalService, sources);
    });
  }
  function queryPriceRecommendationShoppingData(matchingReferenceService, parameters) {
    return shoppingRest.get(parameters).then(function (response) {
      return _.filter(response.flattenedPriceRecommendationShoppingData, function (d) {
        return d.source === 'COMPETITORFARE' || _.isNil(matchingReferenceService) || d.shoppingRecordId === matchingReferenceService.shoppingRecordId || d.matchingShoppingRecordIds.indexOf(matchingReferenceService.shoppingRecordId) !== -1;
      });
    });
  }
  function retrieveHostMarketConfigCache() {
    var hostCarrier = configurationService.getHostCarrier();
    var selectedMarket = legendFilterService.getSelectedMarket();
    var marketOrigin = selectedMarket.split('-')[0];
    var marketDestination = selectedMarket.split('-')[1];
    var key = _.cloneDeep([hostCarrier, marketOrigin, marketDestination].join('.'));
    if (_.isUndefined(fpMarketConfigCache[key])) {
      return hepService.getFPMarketConfigParams(marketOrigin, marketDestination).then(function (marketConfig) {
        fpMarketConfigCache[key] = marketConfig.hepList[0].properties.marketConfigParams;
        return fpMarketConfigCache[key];
      });
    }
    return $q.when(fpMarketConfigCache[key]);
  }
  function retrieveData(referenceService, originalService, snapshotDate) {
    return retrieveHostMarketConfigCache().then(function (hostMarketConfig) {
      var isShiftShopping = hostMarketConfig.isShiftShopping;
      var restParameters = {};
      var filters = searchCriteriaService.getSearchCriteria(referenceService, originalService, snapshotDate, isShiftShopping);
      if (filters) {
        restParameters.filter = filters;
        restParameters.pageLimit = -1;
      }
      return _.isNil(referenceService) ? retrieveOneWayData(restParameters, originalService) : retrieveRoundTripData(restParameters, originalService, referenceService);
    });
  }
  function retrieveOneWayData(restParameters, originalService) {
    var sources = [originalService.source];
    return queryPriceRecommendationShoppingData(originalService, restParameters).then(retrieveFpNesting).then(_.partialRight(filter, originalService, sources)).then(_.partialRight(transform, originalService));
  }
  function retrieveRoundTripData(restParameters, originalService, referenceService) {
    var matchingReferenceService = _.find(referenceService.data, function (d) {
      return d.originalServiceId === originalService.serviceId;
    });
    var originalServiceSource = !_.isNil(matchingReferenceService) ? originalService.sources[originalService.referenceServiceIds.indexOf(matchingReferenceService.serviceId)] : originalService.source;
    var referenceServiceSource = _.get(matchingReferenceService, 'source') || referenceService.source;
    var sources = _.uniq([originalServiceSource, referenceServiceSource]);
    return queryPriceRecommendationShoppingData(matchingReferenceService, restParameters).then(retrieveFpNesting).then(_.partialRight(filter, originalService, sources)).then(_.partialRight(competitorDataFilterService.filterLatestShoppingData)).then(_.partialRight(transform, referenceService));
  }
  function retrieveFpNesting(competitorCompFares) {
    var carriers = getCarriers(competitorCompFares);
    var market = legendFilterService.getSelectedMarket();
    var marketOrigin = market.split('-')[0];
    var marketDestination = market.split('-')[1];
    var promises = [competitorCompFares];
    for (var i = 0; i < carriers.length; i++) {
      promises.push(callForFpNesting(carriers[i], marketOrigin, marketDestination));
    }
    return promises;
  }
  function callForFpNesting(carrier, marketOrigin, marketDestination) {
    var key = _.cloneDeep([carrier, marketOrigin, marketDestination].join('.'));
    if (!_.isUndefined(fpNestingsCache[key])) {
      return;
    }
    var filterItems = 'carrier==' + carrier + ';marketOrigin==' + marketOrigin + ';marketDestination==' + marketDestination;
    return hepFpNestingRest.get({
      type: 'FP_Nesting',
      filter: filterItems
    }).then(function (nesting) {
      fpNestingsCache[key] = nesting.hepList[0].properties.nestingParams;
    });
  }
  return {
    retrieveData: retrieveData
  };
};
CompetitorDataGridDataService.$inject = ['Restangular', 'SearchCriteriaRuleFactory', 'RsqlQueryFactory', '$q', 'MomentService', 'PricingDepartureDatesLegendFilterService', 'HepService', 'ConfigurationService', 'CompetitorDataSearchCriteriaService', 'CompetitorDataFilterService'];
module.exports = CompetitorDataGridDataService;